import React, { useContext, useEffect, useState } from 'react';
import { EllipsisSpan, Input, MxColumnsType, Radio } from '@maxtropy/components';
import { DataPointType } from '@/shared/types';
import Point from '@/shared/components/EdgeDevicePointInfo/mockingbird/Point';
import Virtual from '@/shared/components/EdgeDevicePointInfo/mockingbird/Virtual';
import styles from '../index.module.scss';
import StaticSpot from '@/shared/components/EdgeDevicePointInfo/mockingbird/Static';
import { PointContext } from '@/shared/components/EdgeDevicePointInfo/contextTypes';
import { RadioChangeEvent } from 'antd/es/radio';
import useIsGateway from '@/shared/hooks/useIsGateway';
import dayjs from 'dayjs';
import { Space } from 'antd';
import { Link, useParams } from 'react-router-dom';

export interface SearchParams {
  name?: string;
  pointType?: DataPointType;
}

interface EdgePointDetailProps {
  loading?: boolean;
  setSearchParams?: (searchParams: SearchParams) => void;
  hasDataColumns?: boolean;
}

export const dataColumns: MxColumnsType<any> = [
  {
    title: '实时数据',
    dataIndex: 'edgeData',
    ellipsis: { showTitle: true },
    width: 120,
    render: (v: string) => <EllipsisSpan value={v ? (isNaN(Number(v)) ? v : (+v).toFixed(4)) : v} />,
  },
  {
    title: '采集时间',
    dataIndex: 'edgeTime',
    ellipsis: { showTitle: true },
    width: 180,
    render: (v: string) => <EllipsisSpan value={v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : undefined} />,
  },
];

const EdgePointDetail: React.FC<EdgePointDetailProps> = props => {
  const { loading, setSearchParams, hasDataColumns } = props;

  const [activeKey, setActiveKey] = useState<DataPointType>();
  const [searchValue, setSearchValue] = useState('');
  const { info } = useContext(PointContext);
  const { loading: isGatewayLoading, isGateway } = useIsGateway(info?.deviceTypeId);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (isGatewayLoading) return;
    if (isGateway) {
      setActiveKey(DataPointType.STATIC_POINT);
    } else {
      setActiveKey(DataPointType.BASE_POINT);
    }
  }, [isGatewayLoading, isGateway]);

  useEffect(() => {
    if (activeKey) {
      setSearchParams?.({ pointType: +activeKey, name: searchValue });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, searchValue]);

  if (isGatewayLoading) return null;

  return (
    <div className={styles.container}>
      <div className={styles.optionRow}>
        <Space size={8}>
          <Radio.Group
            buttonStyle="solid"
            onChange={(e: RadioChangeEvent) => {
              setActiveKey(e.target.value);
            }}
            value={activeKey}
          >
            <Radio.Button value={1}>采集点</Radio.Button>
            <Radio.Button value={2}>虚拟点</Radio.Button>
            <Radio.Button value={3}>静态点</Radio.Button>
          </Radio.Group>

          <Link target="_blank" to={`/data/history/device?deviceId=${id}&from=deviceDetail`}>
            查看历史数据
          </Link>
        </Space>

        <div>
          <Input.Search
            style={{ width: 260 }}
            placeholder="请输入数据属性名称/标识符"
            allowClear
            onSearch={setSearchValue}
          />
        </div>
      </div>

      {!isGateway && activeKey === DataPointType.BASE_POINT && (
        <Point loading={loading} editColumns={hasDataColumns ? dataColumns : []} />
      )}
      {!isGateway && activeKey === DataPointType.VIRTUAL_POINT && (
        <Virtual loading={loading} editColumns={hasDataColumns ? dataColumns : []} />
      )}
      {activeKey === DataPointType.STATIC_POINT && (
        <StaticSpot loading={loading} editColumns={hasDataColumns ? dataColumns : []} />
      )}
    </div>
  );
};

export default EdgePointDetail;
